/**
 * Terminal store: identifica la caja física pareada con esta PWA.
 *
 * Persistido en localStorage. Tras login, si el cajero no tiene un terminal
 * pareado, se le muestra el SelectTerminalPage. Las requests al backend que
 * necesitan terminal context lo levantan de acá vía el header `X-Terminal-Id`
 * inyectado por el cliente HTTP.
 */

import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

/** Snapshot del terminal pareado. Incluye los defaults de serie para que la
 *  PWA preseleccione al emitir sin tener que volver a fetchear el terminal.
 *
 *  Esto puede quedar levemente stale si un admin cambia los defaults mientras
 *  el cajero está paireado — la solución es deshacer el pairing (botón "cambiar
 *  caja" en el header del POS) o cerrar/abrir sesión. Para v1 es aceptable. */
interface PairedTerminal {
  id: string;
  code: string;
  name: string;
  branchId: string;
  default_boleta_series_id: string | null;
  default_factura_series_id: string | null;
  default_nota_venta_series_id: string | null;
}

interface TerminalState {
  terminal: PairedTerminal | null;
  pair: (terminal: PairedTerminal) => void;
  unpair: () => void;
}

export const useTerminalStore = create<TerminalState>()(
  persist(
    (set) => ({
      terminal: null,
      pair: (terminal) => set({ terminal }),
      unpair: () => set({ terminal: null }),
    }),
    {
      name: "sistema-sale-pos.terminal",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
